import Swal from "sweetalert2";
import { useTheme } from "styled-components";

type GuardedContact = {
  userCompanyId?: string | null;
  realEstateId?: string | null;
};

export type ArchiveGuardChoice = 'archive' | 'associate' | 'none';

/**
 * Antes de abrir o modal de arquivamento, verifica se o contato tem imobiliária
 * vinculada. Se não tiver, o atendimento não será registrado no sistema, então
 * o atendente é avisado e escolhe entre associar uma imobiliária (editar
 * contato) ou seguir para o arquivamento sem imobiliária.
 */
export function useArchiveGuard() {
  const theme = useTheme();

  async function resolveArchiveAction(contact: GuardedContact): Promise<ArchiveGuardChoice> {
    const hasRealEstateLink = !!(contact.userCompanyId || contact.realEstateId);

    if (hasRealEstateLink) return 'archive';

    const result = await Swal.fire({
      title: 'Contato sem imobiliária vinculada',
      text: 'Este contato não está vinculado a nenhuma imobiliária, então o atendimento não será registrado no sistema. Deseja associar uma imobiliária antes ou arquivar sem imobiliária?',
      icon: 'warning',
      showCancelButton: true,
      showConfirmButton: true,
      cancelButtonText: 'Associar imobiliária',
      confirmButtonText: 'Arquivar sem imobiliária',
      confirmButtonColor: theme.colors.danger,
      reverseButtons: true,
    });

    if (result.isConfirmed) return 'archive';
    if (result.dismiss === Swal.DismissReason.cancel) return 'associate';

    // ESC / clique fora: aborta sem abrir nenhum modal.
    return 'none';
  }

  return resolveArchiveAction;
}
